"use client";

import React, { createContext, useContext } from "react";

interface EmbeddedContextType {
  isEmbedded: boolean;
}

const EmbeddedContext = createContext<EmbeddedContextType>({
  isEmbedded: false,
});

export const useEmbedded = () => useContext(EmbeddedContext);

export const EmbeddedProvider: React.FC<{
  isEmbedded: boolean;
  children: React.ReactNode;
}> = ({ isEmbedded, children }) => {
  return (
    <EmbeddedContext.Provider value={{ isEmbedded }}>
      {children}
    </EmbeddedContext.Provider>
  );
};
